export default "__VITE_ASSET__D2DEYXjl__"